module.exports = __webpack_public_path__ + "img/bg4.071b9269.png";